import React from "react";
import CowsPage from "./CowsPage";
import useCows from "./useCows";

function Cows(props) {
  return <CowsPage {...useCows(props)} />;
}

export default Cows;
